import { NET } from "@besenliga/shared";
import { TICK_SECONDS } from "./world.js";

/**
 * Converte o tempo real dos quadros em ticks fixos de 1/30 s.
 * Um monitor de 144 Hz e outro de 30 Hz executam exatamente os mesmos ticks;
 * só muda quantos ticks rodam em cada quadro.
 */
export class FixedStepClock {
  private accumulator = 0;

  /** Quanto do próximo tick já passou, em [0, 1): usado para interpolar o desenho. */
  get alpha(): number {
    return this.accumulator / TICK_SECONDS;
  }

  /** Recebe o tempo do quadro, em segundos, e devolve quantos ticks rodar agora. */
  advance(elapsedSeconds: number): number {
    if (!(elapsedSeconds > 0)) return 0;
    this.accumulator += elapsedSeconds;
    let ticks = Math.floor(this.accumulator / TICK_SECONDS + 1e-9);
    this.accumulator -= ticks * TICK_SECONDS;
    if (this.accumulator < 0) this.accumulator = 0;
    if (ticks > NET.maxCatchUpTicks) {
      ticks = NET.maxCatchUpTicks;
      this.accumulator = 0;
    }
    return ticks;
  }

  reset(): void {
    this.accumulator = 0;
  }
}
